"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "chienes": {
    "49649225": [{
      "hkey": "a1e825b3",
      "slug": "chienes",
      "name": "Chienes",
      "primary": true,
      "skipSearch": false
    }],
    "corti": [{
      "hkey": "a1e825b3",
      "slug": "chienes",
      "name": "Chienes",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3c66e8fa": [{
      "hkey": "a1e825b3",
      "slug": "chienes",
      "name": "Chienes",
      "primary": true,
      "skipSearch": false
    }],
    "monghezzo": [{
      "hkey": "a1e825b3",
      "slug": "chienes",
      "name": "Chienes",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;